(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('pageTitle', function($rootScope, resourceService) {
    return {
        restrict: 'A',
        link(scope, el, attr) {
            const defaultTitle = attr.pageTitle;
            const resources = {
                transfers: 'TRANSFERSHOMEPAGETITLE'
            };

            $rootScope.$on('$routeChangeStart', function(scope, next) {
                if (!next.landing) {
                    let title = defaultTitle;
                    const resource = resources[next.area];
                    if (resource) {
                        title = resourceService.get(resource);
                    }
                    document.title = title;
                }
            });
        }
    };
});
})();
